import { useEffect, useState } from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { move, reorder, getItemStyle, getListStyle } from '../tools'

export const Picture = ({ title = '', items: pItems = [] }) => {
  const [items, setItems] = useState({})

  useEffect(() => {
    const bItems = {
      sourceList: pItems,
      pictureList: [],
    }
    setItems(bItems)
  }, [pItems])

  const onDragEnd = (result) => {
    const { source, destination } = result

    // dropped outside the list
    if (!destination) {
      return
    }

    if (source.droppableId === destination.droppableId) {
      const newItems = reorder(
        items[source.droppableId],
        source.index,
        destination.index,
      )

      setItems({
        ...items,
        [source.droppableId]: newItems,
      })
    } else {
      console.log(source, destination, items)

      const result = move(
        items[source.droppableId],
        items[destination.droppableId],
        source,
        destination,
      )

      setItems({
        ...items,
        [source.droppableId]: result[source.droppableId],
        [destination.droppableId]: result[destination.droppableId],
      })
    }
  }

  return (
    <>
      <p dangerouslySetInnerHTML={{ __html: title }} />

      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="sourceList" direction="horizontal">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={{
                ...getListStyle(snapshot.isDraggingOver),
                background: 'white',
              }}
            >
              {(items.sourceList || []).map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      // style={getItemStyle(
                      //     snapshot.isDragging,
                      //     provided.draggableProps.style
                      // )}
                      // dangerouslySetInnerHTML={{__html: item.content }}
                    >
                      <img
                        src="/account/img/dnd/bat.svg"
                        width={64}
                        height={64}
                        alt=""
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>

        <Droppable droppableId="pictureList" direction="horizontal">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={{
                ...getListStyle(snapshot.isDraggingOver),
                background: 'url(/account/img/dnd/moon.jpg)',
                width: 414,
                height: 368,
              }}
            >
              {(items.pictureList || []).map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      // style={getItemStyle(
                      //     snapshot.isDragging,
                      //     provided.draggableProps.style
                      // )}
                      // dangerouslySetInnerHTML={{__html: item.content }}
                    >
                      <img
                        src="/account/img/dnd/bat.svg"
                        width={64}
                        height={64}
                        alt=""
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </>
  )
}
